const SESSION_STORAGE_PREFIX = String(import.meta.env.VITE_APP_CONFIG ?? '')
  .toUpperCase()
  .replaceAll('-', '_');

export const getSession = (key: string) => sessionStorage.getItem(getKey(key));

export const setSession = (key: string, value: string) => {
  sessionStorage.setItem(getKey(key), value);
};

const getKey = (key: string) => `${SESSION_STORAGE_PREFIX}_${key}`;
